// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* 外觀樣式定義在全域 style.css，這裡只處理 GIS 覆蓋層的定位 */\n.social-login-buttons[data-v-51049444] {\n  position: relative;\n}\n/* GIS 官方按鈕以透明層蓋在自訂按鈕上，點擊實際由官方按鈕接收 */\n.google-login-render[data-v-51049444] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  opacity: 0.001;\n}\n", ""]);
// Exports
module.exports = exports;
